import { createSelector } from "@reduxjs/toolkit"

export const selectRefreshToken = (state) => {
  return state.user.refreshToken
}

export const selectIsAuthenticated = createSelector(selectRefreshToken, (token) => {
  return !!token
})

export const selectUserId = (state) => {
  return state.user.id
}

export const selectUsername = (state) => {
  return state.user.username
}

export const selectRankingPoints = (state) => {
  return state.user.rankingPoints
}

export const selectRankingPosition = (state) => state.user.rankingPosition ?? null

export const selectEmail = (state) => {
  return state.user.email
}

// When the player may next take a new name, as an ISO string, or null if they may right now.
// Read from the server rather than counted here: the cooldown is the server's rule, and a date
// this client worked out for itself would be a second opinion on it.
export const selectNextUsernameChangeAt = (state) => state.user.nextUsernameChangeAt ?? null

export const selectCanChangeUsername = createSelector(
  selectNextUsernameChangeAt,
  (allowedAt) => !allowedAt || new Date(allowedAt) <= new Date()
)

export const selectGoogleLinked = (state) => Boolean(state.user.googleLinked)
// Which Google account, for the profile's "Linked as …". Null on an account that has none, and on
// a payload from a server older than the field — the caller falls back to the bare "Linked".
export const selectGoogleEmail = (state) => state.user.googleEmail || null
export const selectHasPassword = (state) => state.user.hasPassword !== false

// Whether basic training has yet to open for this account — the server's `basic_training_seen_at`
// being null. `routes.js` walks a signed-in player into `/tutorial` while it is true.
export const selectBasicTrainingPending = (state) => Boolean(state.user.basicTrainingPending)

// A guest account (owner, 2026-10-02): playing under a funny name, with an address
// the game made up (`<name>@zombies-vs-humans.com`) and no password.
// The shop is closed to it (the server refuses, `GuestsCannotShop`) and the profile offers to save it.
export const selectIsGuest = (state) => Boolean(state.user.isGuest)

// Staff may watch any game in progress (`WatchGamesModal`); the server is the gate (`IsAdminUser`).
export const selectIsStaff = (state) => Boolean(state.user.isStaff)
